import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import application from '~/redux/reducers/application';
import companySearch from '~/redux/reducers/companySearch';
import itinerarySearch from '~/redux/reducers/itinerarySearch';
import notifications from '~/redux/reducers/notifications';
import impersonationLogs from '~/redux/reducers/impersonationLogs';
import messageLogs from '~/redux/reducers/messageLogs';
import selectedCompanyID from '~/redux/reducers/selectedCompanyID';
import userState from '~/redux/reducers/userState';
import userSearch from '~/redux/reducers/userSearch';

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    application,
    companySearch,
    impersonationLogs,
    itinerarySearch,
    notifications,
    messageLogs,
    selectedCompanyID,
    userState,
    userSearch,
  });

export default createRootReducer;
